var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSmallPictures(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 1,
    y: 1,
    stroke: "#FFF",
    strokeWidth: 2,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 11,
    y: 4,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M1.014 13.268l2.596-2.596c.376-.377.982-.392 1.377-.035l9.366 8.46h0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M10 15.268l2.602-2.602c.374-.374.975-.392 1.37-.04l4.984 4.42h0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmallPictures);
export default __webpack_public_path__ + "static/media/icon-small-pictures.877f95a4.svg";
export { ForwardRef as ReactComponent };